import { useBaseURL } from '@/shared/composables/url'

import { appBaseUrl, isDevelopment, isElectron, isNotDevelopment, tauriMode } from '../import-meta'

const APP_IMAGE_ORIGIN = 'http://appimage.localhost'

export const getFullURL = (path = '') => {
  if (path && path.startsWith('data:image')) {
    return path
  }

  if (path.startsWith('blob:')) {
    return path
  }

  if ((tauriMode() || isElectron()) && path) {
    return `${appBaseUrl()}${path}`
  } else {
    const { baseURL } = useBaseURL()
    return baseURL === '/' ? path : `${baseURL}${path}`
  }
}

export const getPathNameFromURL = (url: string) => {
  try {
    const { pathname } = new URL(url)
    return pathname
  } catch {
    return url
  }
}

export const getAbsoluteURL = (path: string) => {
  if (tauriMode() || isElectron() || isDevelopment()) {
    return `${appBaseUrl()}${path}`
  } else {
    const { baseURL } = useBaseURL()
    const resultPath = baseURL === '/' ? path : `${baseURL}${path}`
    return `${window.location.origin}${resultPath}`
  }
}

export const getAbsoluteWebSocketURL = (path: string) => {
  const protocol = (!tauriMode() && isNotDevelopment() && location.hostname === 'localhost') ? 'ws://' : 'wss://'
  return getAbsoluteURL(path).replace(/http(s)?:\/\//, protocol)
}

const isLocalOrDataUrl = (path: string) =>
  /^(blob:|data:)/i.test(path)

export const getAuthenticatedMediaUrl = (path = '') => {
  if (!path || isLocalOrDataUrl(path)) return path
  if (!tauriMode()) return getFullURL(path)

  const pathname = /^https?:/i.test(path)
    ? getPathNameFromURL(path)
    : (path.startsWith('/') ? path : `/${path}`)

  return `${APP_IMAGE_ORIGIN}${pathname}`
}
